import { type DeepiToastProps } from '@deepidoo/deesplay/components/toast/DeepiToast.vue';

export const toastMessages = {
	error: {
		accountTestFailed: {
			title: 'playdoo.components.toast.error.account-test-failed.title',
			text: 'playdoo.components.toast.error.account-test-failed.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		badLogin: {
			title: 'playdoo.components.toast.error.bad-login.title',
			text: 'playdoo.components.toast.error.bad-login.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		badRequest: {
			title: 'playdoo.components.toast.error.bad-request.title',
			text: 'playdoo.components.toast.error.bad-request.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		cloudPickerError: {
			title: 'playdoo.components.toast.error.cloud-picker-error.title',
			text: 'playdoo.components.toast.error.cloud-picker-error.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		fileTooLarge: {
			title: 'playdoo.components.toast.error.file-too-large.title',
			text: 'playdoo.components.toast.error.file-too-large.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		fileInvalidExtension: {
			title: 'playdoo.components.toast.error.file-invalid-extension.title',
			text: 'playdoo.components.toast.error.file-invalid-extension.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		fileInvalidZip: {
			title: 'playdoo.components.toast.error.file-invalid-zip.title',
			text: 'playdoo.components.toast.error.file-invalid-zip.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		default: {
			title: 'playdoo.components.toast.error.default.title',
			text: 'playdoo.components.toast.error.default.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		forbidden: {
			title: 'playdoo.components.toast.error.forbiden.title',
			text: 'playdoo.components.toast.error.forbiden.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		gatewayError: {
			title: 'playdoo.components.toast.error.gateway-error.title',
			text: 'playdoo.components.toast.error.gateway-error.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		notFound: {
			title: 'playdoo.components.toast.error.not-found.title',
			text: 'playdoo.components.toast.error.not-found.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		serverError: {
			title: 'playdoo.components.toast.error.server-error.title',
			text: 'playdoo.components.toast.error.server-error.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		unauthorized: {
			title: 'playdoo.components.toast.error.unauthorized.title',
			text: 'playdoo.components.toast.error.unauthorized.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		},
		unprocessable: {
			title: 'playdoo.components.toast.error.unprocessable.title',
			text: 'playdoo.components.toast.error.unprocessable.text',
			color: 'error',
			icon: 'icon-error',
			timeout: 5000
		}
	},
	success: {
		accountTested: {
			title: 'playdoo.components.toast.success.account-tested.title',
			text: 'playdoo.components.toast.success.account-tested.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		emailSent: {
			title: 'playdoo.components.toast.success.email-sent.title',
			text: 'playdoo.components.toast.success.email-sent.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		messageOrdered: {
			title: 'playdoo.components.toast.success.message-ordered.title',
			text: 'playdoo.components.toast.success.message-ordered.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		passwordReset: {
			title: 'playdoo.components.toast.success.password-reset.title',
			text: 'playdoo.components.toast.success.password-reset.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		passwordSetup: {
			title: 'playdoo.components.toast.success.password-setup.title',
			text: 'playdoo.components.toast.success.password-setup.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		passwordUpdated: {
			title: 'playdoo.components.toast.success.password-updated.title',
			text: 'playdoo.components.toast.success.password-updated.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		},
		performanceTrialStarted: {
			title: 'playdoo.components.toast.success.performance-trial-started.title',
			text: 'playdoo.components.toast.success.performance-trial-started.text',
			color: 'success',
			icon: 'icon-check',
			timeout: 5000
		}
	},
	warning: {
		networkSlow: {
			title: 'playdoo.components.toast.warning.network-slow.title',
			text: 'playdoo.components.toast.warning.network-slow.text',
			color: 'warning',
			icon: 'icon-warning',
			timeout: 5000
		}
	}
} satisfies Record<string, Record<string, DeepiToastProps>>;

export type ToastCategory = keyof typeof toastMessages;
export type ToastKey<T extends ToastCategory> = keyof typeof toastMessages[T];